type LengthValidator = (input: string) => boolean;

export const lengthValidator = (minLength: number, maxLength: number): LengthValidator => {
    return (input: string) => input !== null && input.length >= minLength && input.length <= maxLength;
};

export const maxLengthValidator = (maxLength: number): LengthValidator => {
    return (input: string | null | undefined) => input == null || input.length <= maxLength;
}